import useSettingsGlobals from '@/composables/useSettingsGlobals'
const { $PLATFORM = null } = useSettingsGlobals();

export const useWebviewMessenger = () => {
  const send = (messageObject) => {
    if (!$PLATFORM) {
      console.error('webviewMessenger requires $PLATFORM to be set');
      return;
    }
    
    if (typeof messageObject !== 'object') {
      console.error('webviewMessenger expects an object as the first argument');
      return;
    }

    if (!messageObject.type) {
      console.error('webviewMessenger expects an object with a "type" property');
      return;
    }
  
    if ($PLATFORM === 'android') {
      const type = messageObject.type;
      delete messageObject.type;

      const values = Object.values(messageObject);
      const message = [type, ...values].join(',');
    
      alert(message);
    } else {
      window.webkit.messageHandlers.observe.postMessage(messageObject);
    }
  }

  return { send }
}
